module.exports = __webpack_public_path__ + "img/price-bg.6fb4df54.gif";